// API base URL — resolved at runtime from window.location so the same build
// works for localhost dev, LAN pilot testing, and Cloudflare tunnel production.
//
// Priority:
//   1. REACT_APP_API_BASE_URL (baked at build time) — explicit override for CI/CD
//   2. Runtime detection from window.location (handles all other cases)

let API_BASE_URL;

if (process.env.REACT_APP_API_BASE_URL) {
  // Explicit override: set this env var before `npm run build` to hardcode a URL.
  API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
} else {
  const host  = window.location.hostname;
  const port  = window.location.port;   // empty string on default 80/443
  const proto = window.location.protocol;

  if (host === 'localhost' || host === '127.0.0.1') {
    // React dev server (port 3000) — API runs separately on 5001
    API_BASE_URL = `http://${host}:5001`;
  } else if (port) {
    // LAN pilot test: both frontend and API served by the same Express server
    // (e.g. node server.js on :5001, iPhone hits http://172.20.10.6:5001)
    API_BASE_URL = `${proto}//${host}:${port}`;
  } else {
    // Named domain / tunnel (Cloudflare, ngrok, production) — no explicit port
    API_BASE_URL = `${proto}//${host}`;
  }
}

export { API_BASE_URL };
